import { Footer } from '../homepage/Footer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TermsMessages as m } from './TermsPage.messages';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import './static-page.css';

export const TermsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
    <PageSeo
      path="/terms"
      titleKey="seo.terms.title"
      descriptionKey="seo.terms.description"
      noindex
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Terms', path: '/terms' }])]}
    />
    <div className="page-wrapper"><div className="static-page">
      <h1>{t(m.PAGE_TITLE)}</h1>
      <p className="page-subtitle">{t(m.SUBTITLE)}</p>

      <h2>{t(m.SERVICE_TITLE)}</h2>
      <p>{t(m.SERVICE_DESC)}</p>

      <h2>{t(m.ACCOUNTS_TITLE)}</h2>
      <p>{t(m.ACCOUNTS_DESC)}</p>

      <h2>{t(m.FREE_TRIAL_TITLE)}</h2>
      <p>{t(m.FREE_TRIAL_DESC)}</p>

      <h2>{t(m.SUBSCRIPTIONS_TITLE)}</h2>
      <p>{t(m.SUBSCRIPTIONS_DESC)}</p>

      <h2>{t(m.USAGE_LIMITS_TITLE)}</h2>
      <p>{t(m.USAGE_LIMITS_DESC)}</p>

      <h2>{t(m.YOUR_CONTENT_TITLE)}</h2>
      <p>{t(m.YOUR_CONTENT_DESC)}</p>

      <h2>{t(m.ACCEPTABLE_USE_TITLE)}</h2>
      <p>{t(m.ACCEPTABLE_USE_DESC)}</p>

      <h2>{t(m.AVAILABILITY_TITLE)}</h2>
      <p>{t(m.AVAILABILITY_DESC)}</p>

      <h2>{t(m.TERMINATION_TITLE)}</h2>
      <p>{t(m.TERMINATION_DESC)}</p>

      <h2>{t(m.CHANGES_TITLE)}</h2>
      <p>{t(m.CHANGES_DESC)}</p>

      <h2>{t(m.CONTACT_TITLE)}</h2>
      <p dangerouslySetInnerHTML={{ __html: t(m.CONTACT_DESC) }} />

      <p className="last-updated">{t(m.LAST_UPDATED)}</p>
    </div>
    <Footer />
    </div>
    </>
  );
};
